export default {"src":"/_next/static/media/check_regular.48f18fdb.svg","height":24,"width":24};